import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { useLocation, useNavigate } from 'react-router-dom';
 

// Fonction pour formater les dates etl'heure
const lastUpdate = '2025-12-15T00:00:00Z'; // ou un autre ISO valide

  const formatDate = (isoDate, language = 'fr') => {
  const date = new Date(isoDate);

  const locales = {
    fr: 'fr-FR',
    en: 'en-US',
    de: 'de-DE',
    es: 'es-ES',
    pt: 'pt-PT',
    it: 'it-IT',
    hu: 'hu-HU',
    uk: 'uk-UA',
    sv: 'sv-SE',
    nl: 'nl-NL',
    fi: 'fi-FI',
    pl: 'pl-PL',
    ro: 'ro-RO',
    el: 'el-GR',
    no: 'no-NO',
    da: 'da-DK',
    cs: 'cs-CZ',
    sk: 'sk-SK',
    hr: 'hr-HR',
    lt: 'lt-LT',
    et: 'et-EE',
    lv: 'lv-LV',
    bg: 'bg-BG',
    sl: 'sl-SI',
    sr: 'sr-RS',
    is: 'is-IS',
    ar: 'ar-AR',
mt: 'mt-MT',


    // Ajoute d'autres langues ici si besoin
  };

  const locale = locales[language] || 'fr-FR'; // fallback par défaut

  const formattedDate = date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return formattedDate;
};

const TermsOfUse = () => {
const { t } = useTranslation();
const language = i18n.language;

const location = useLocation();
const navigate = useNavigate();

const fromDiscussionId = location.state?.fromDiscussion;
const handleBackToDiscussions = () => {
    if (fromDiscussionId) {
      // Revenir à la discussion fullscreen
      navigate('/', {
        state: { reopenDiscussionId: fromDiscussionId },
      });
    } else {
      navigate(-1); // comportement par défaut
    }
  };


  return (
    <div style={{ position: 'relative', top: '10px' }} className="p-4 max-w-3xl mx-auto text-justify text-sm leading-6">

      <h1 className="text-2xl font-bold mb-4">{t('infos.titre')}</h1>
      
      <p>
       {t('infos.texte1')}
      </p>

      <h2 className="mt-4 font-semibold"> {t('infos.titre1')}</h2>
      <p>
        {t('infos.texte2')}

      </p>

      <h2 className="mt-4 font-semibold">{t('infos.titre2')}</h2>
      <p>
        {t('infos.texte3')}

      </p>

      <h2 className="mt-4 font-semibold">{t('infos.titre3')}</h2>
      <p dangerouslySetInnerHTML={{ __html: t('infos.texte4') }} />
       <p dangerouslySetInnerHTML={{ __html: t('infos.texte5') }} />
        
<p>
        {t('infos.texte6')}

      </p>
<h2 className="mt-4 font-semibold">{t('infos.titre7')}</h2>
<p dangerouslySetInnerHTML={{ __html: t('infos.texte15') }} />
       
<p dangerouslySetInnerHTML={{ __html: t('infos.texte16') }} />
        
<p dangerouslySetInnerHTML={{ __html: t('infos.texte18') }} />
        

<h2 className="mt-4 font-semibold">{t('infos.titre8')}</h2>
<p style={{ whiteSpace: 'pre-line' }}>
       {t('infos.texte17')}

      </p>

<h2 className="mt-4 font-semibold">{t('infos.titre4')}</h2>
      <p>
        {t('infos.texte7')}

      </p>
<p>
        {t('infos.texte9')}

      </p>

<h2 className="mt-4 font-semibold">{t('infos.titre5')}</h2>
<p>
        {t('infos.texte12')}
      </p>

      <h2 className="mt-4 font-semibold">{t('infos.titre6')}</h2>
      <p> 
         {t('infos.texte13')}

</p>
      <p className="mt-6 text-sm italic">
          {t('infos.texte14')}<strong>{formatDate(lastUpdate, language)}</strong>
      </p>
    </div>
  );
};

export default TermsOfUse;
